import * as actions from "../constants/actionTypes";

export const INITIAL_STATE = {
    open: false,
    message: "",
    withButton: false,
    buttonText: "",
    notifyType: 1,
    autoClose: true,
    redirectURL: "",
    isFront: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.MODAL_OPEN:
            let modalData = {
                open: false,
                message: "",
                withButton: false,
                buttonText: "",
                notifyType: 1,
                autoClose: true,
                redirectURL: "",
                isFront: false,
            };
            modalData.message = action.payload.message;
            modalData.open = true;
            if (action.payload.withButton != undefined || action.payload.withButton == true) {
                modalData.withButton = true;
            }
            if (action.payload.buttonText != undefined) {
                modalData.buttonText = action.payload.message;
            }
            if (action.payload.notifyType != undefined) {
                modalData.notifyType = action.payload.notifyType;
            }
            if (action.payload.isFront != undefined) {
                modalData.isFront = action.payload.isFront;
            }
            if (action.payload.autoClose != undefined) {
                modalData.autoClose = action.payload.autoClose;
            }
            if (action.payload.redirectURL != undefined) {
                modalData.redirectURL = action.payload.redirectURL;
            }
            return {
                ...state,
                ...modalData,
            }
        case actions.MODAL_CLOSE:
            return {
                open: false,
                message: "",
                withButton: false,
                buttonText: "",
                notifyType: 1,
                autoClose: true,
                redirectURL: "",
                isFront: false,
            }
        default:
            return state;
    }
}